// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2762":"122f4985","7874":"31d6cfe0","7889":"03825bf7","9646":"aa4b4e16","9947":"9e21694d"}[chunkId] + ".chunk.css";
};